import React from "react";
import { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Flex,
  HStack,
  Box,
  Icon,
  SimpleGrid,
  Text,
  Textarea,
  Radio,
  RadioGroup,
  Stack,
  VisuallyHidden,
  Select,
  useColorModeValue,
  useColorMode,
  color,
  Skeleton,
  Divider
} from "@chakra-ui/react";

import { toast } from "react-toastify";

import ReactSelect from "react-select";
import Creatable from 'react-select/creatable';

import locations from "variables/locations";

import { CheckIcon } from "@chakra-ui/icons";

import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  Checkbox,
  CheckboxGroup,
} from "@chakra-ui/react";

import {
  onSiteVehiclesOptionsJRG1,
  onSiteVehiclesOptionsJRG2,
  onSiteVehiclesOptionsSP,
  onSiteVehiclesOptionsWSP,
  sluzby,
  grupy,
} from "variables/general";

import Card from "components/Card/Card.js";
import CustomCheckbox from "components/Checkbox/CustomCheckbox";
import axios from "axios";
import apiUrl from "../../../variables/api";
import { set } from "react-hook-form";
import darkStyles from "variables/darkStyles";
import CustomCheckboxButton from "components/Checkbox/CustomCheckboxButton";

import { format, toZonedTime } from 'date-fns-tz';

const refreshDateTime = () => {
  const now = new Date();
  const timeZone = 'Europe/Warsaw';
  const polandTime = toZonedTime(now, timeZone);
  return format(polandTime, "yyyy-MM-dd'T'HH:mm");
};

const initialValues = {
  dateTime: refreshDateTime(),
  location: "",
  peoplesOnSite: [],
  onSiteVehicles: [],
  incidentDescription: "",
};


export default function Incident() {
  // console.log("style", darkStyles())
  const { colorMode } = useColorMode();

  const [peoples, setPeoples] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        response.data.push({ value: "WSP", label: "WSP" });
        setPeoples(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  const [vehicles, setVehicles] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/vehicles", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        const vehicles = response.data;
        const formattedData = vehicles.reduce((acc, item) => {
          const existingUnit = acc.find((unit) => unit.unit === item.unit);
          if (existingUnit) {
            existingUnit.vehicles.push(item.operationalNumber);
          } else {
            acc.push({ unit: item.unit, vehicles: [item.operationalNumber] });
          }
          return acc;
        }, []);
        setVehicles(formattedData);
        console.log(formattedData);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const validate = (values) => {
    const errors = {};
    const requiredFields = Object.keys(initialValues);
  
    requiredFields.forEach(field => {
      if (!values[field] || values[field]?.length === 0) {
            errors[field] = "To pole jest obowiazkowe";
        }
    });
  
    return errors;
  }


  const [formData, setFormData] = useState(initialValues);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const formikRef = React.useRef();

  const [isOpenImport, setOpenImport] = useState(false);

  const onOpenImport = () => setOpenImport(true);
  const onCloseImport = () => setOpenImport(false);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Dane formularza", values);

    setFormData(values);
    onOpen();
  };

  const handleFinalSubmit = (values) => {
    console.log("Wysyłanie formularza", formData);
    if(!formikRef.current.isSubmitting) return;
    onClose();
    axios
      .post(apiUrl + "/data/sgrt", formData, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.success) {
          formikRef.current.resetForm();
          formikRef.current.setFieldValue("dateTime", refreshDateTime());
          formikRef.current.setFieldValue("peoplesOnSite", []);
          formikRef.current.setSubmitting(false);
          return toast.success("Pomyślnie wysłano kartę wyjazdową");
        } else {
          formikRef.current.setSubmitting(false);
          return toast.error(
            "Napotkano błąd podczas wysyłania karty wyjazdowej"
          );
        }
      })
      .catch((error) => {
        console.error(error);
        formikRef.current.setSubmitting(false);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
    //setSubmitting(false)
  };

  const handleFinalCloseSubmit = (values) => {
    formikRef.current.setSubmitting(false);
    onClose();
    //setSubmitting(false)
  };

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Flex direction="column">
          <Formik
            initialValues={initialValues}
            validate={validate}
            onSubmit={handleSubmit}
            innerRef={formikRef}
          >
            {({ isSubmitting, formik }) => (
              <Form>
                <SimpleGrid
                  columns={{ sm: 1, md: 2, xl: 4 }}
                  spacing="24px"
                  mb="20px"
                >
                  <Field name="dateTime">
                    {({ field, form }) => (
                      <FormControl
                        id="dateTime"
                        isRequired
                        isInvalid={
                          form.errors.dateTime && form.touched.dateTime
                        }
                      >
                        <FormLabel>Data i godzina</FormLabel>
                        <Input
                          type="datetime-local"
                          {...field}
                          placeholder="Data i godzina"
                        />
                        <FormErrorMessage>
                          {form.errors.dateTime}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>

                  <Field name="location">
                    {({ field, form }) => (
                      <FormControl
                        id="location"
                        isRequired
                        isInvalid={
                          form.errors.location && form.touched.location
                        }
                      >
                        <FormLabel>Lokalizacja</FormLabel>
                        <Creatable
                          {...field}
                          options={locations}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values[field.name]}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                          formatCreateLabel={(inputValue) => `Niestandardowa: ${inputValue}`}
                        />
                        <FormErrorMessage>
                          {form.errors.location}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Field name="peoplesOnSite">
                    {({ field, form }) => (
                      <FormControl
                        id="peoplesOnSite"
                        isRequired
                        isInvalid={
                          form.errors.peoplesOnSite &&
                          form.touched.peoplesOnSite
                        }
                      >
                        <FormLabel>Osoby na zdarzeniu</FormLabel>
                        <ReactSelect
                          {...field}
                          noOptionsMessage={() => "Brak dostępnych opcji"}
                          options={peoples}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                            isMulti
                          value={form.values.peoplesOnSite}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                        />
                        <FormErrorMessage>
                          {form.errors.peoplesOnSite}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </SimpleGrid>
                <Field name="onSiteVehicles">
                  {({ field, form }) => (
                    <FormControl
                      id="onSiteVehicles"
                      isInvalid={
                        form.errors.onSiteVehicles &&
                        form.touched.onSiteVehicles
                      }
                    >
                      <FormLabel textAlign={"center"}>
                        <Text fontWeight={"bold"} fontSize={"md"}>
                          Zastępy na miejscu
                        </Text>
                      </FormLabel>
                      <Flex
                        direction={{ base: "column", xl: "row" }}
                        wrap="wrap"
                        justifyContent={{ base: "center", xl: "space-between" }}
                        alignItems="stretch"
                      >
                        {vehicles.length === 0 ? (
                          <Skeleton height="200px" width="100%" />
                        ) : (
                          vehicles.map((unit, index) => (
                            <React.Fragment key={unit.unit}>
                              <Flex direction={"column"} flex="1" mx={2} mb={4}>
                                <FormLabel
                                  fontWeight="bold"
                                  textAlign={"center"}
                                >
                                  {unit.unit}
                                </FormLabel>
                                <SimpleGrid
                                  columns={{ sm: 2, md: 3, xl: 3 }}
                                  spacing="24px"
                                  mb="20px"
                                >
                                  {unit.vehicles.map((vehicle) => (
                                    <CustomCheckboxButton
                                      key={vehicle}
                                      label={vehicle}
                                      isChecked={form.values.onSiteVehicles.includes(
                                        vehicle
                                      )}
                                      onChange={() => {
                                        const nextValue = field.value.includes(
                                          vehicle
                                        )
                                          ? field.value.filter(
                                              (value) => value !== vehicle
                                            )
                                          : [...field.value, vehicle];
                                        form.setFieldValue(
                                          field.name,
                                          nextValue
                                        );
                                      }}
                                    />
                                  ))}
                                </SimpleGrid>
                              </Flex>
                              {index < vehicles.length - 1 && (
                                <Divider
                                  orientation="vertical"
                                  height="auto"
                                  mx={2}
                                />
                              )}
                            </React.Fragment>
                          ))
                        )}
                      </Flex>
                      <FormErrorMessage>
                        {form.errors[field.name]}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="incidentDescription">
                  {({ field }) => (
                    <FormControl id="incidentDescription">
                      <FormLabel>Opis zdarzenia</FormLabel>
                      <Textarea {...field} placeholder="Opis zdarzenia" maxH={"500px"}/>
                    </FormControl>
                  )}
                </Field>

                <Button
                  mt={4}
                  mr={2}
                  colorScheme="red"
                  isLoading={isSubmitting}
                  type="submit"
                >
                  Wyślij
                </Button>

                <AlertDialog
                  isOpen={isOpen}
                  leastDestructiveRef={cancelRef}
                  onClose={onClose}
                >
                  <AlertDialogOverlay>
                    <AlertDialogContent>
                      <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        Potwierdź zgłoszenie
                      </AlertDialogHeader>

                      <AlertDialogBody mt={-3}>
                        Czy na pewno chcesz wysłać te dane? <br />
                        Data i godzina: {formData.dateTime.replace(
                          "T",
                          " "
                        )}{" "}
                        <br />
                        Lokalizacja: {formData.location.label} <br />
                        Osoby na zdarzeniu:{" "}
                        {formData.peoplesOnSite
                          .map((member) => member.label)
                          .join(", ")}{" "}
                        <br />
                        Wozy na miejscu: {formData.onSiteVehicles.join(
                          ", "
                        )}{" "}
                        <br />
                        Opis zdarzenia:{" "}
                        {formData.incidentDescription !== ""
                          ? formData.incidentDescription
                          : "-"}
                      </AlertDialogBody>

                      <AlertDialogFooter>
                        <Button
                          ref={cancelRef}
                          onClick={handleFinalCloseSubmit}
                        >
                          Anuluj
                        </Button>
                        <Button
                          colorScheme="red"
                          onClick={handleFinalSubmit}
                          ml={3}
                        >
                          Wyślij
                        </Button>
                      </AlertDialogFooter>
                    </AlertDialogContent>
                  </AlertDialogOverlay>
                </AlertDialog>
              </Form>
            )}
          </Formik>
        </Flex>
      </Card>
    </Flex>
  );
}
